module.exports = __webpack_public_path__ + "portail/assets/images/banniere02.fc95f8ac.jpg";